<template>
    <validation class="form-group" :class="{ hasError: hasErrors, hasSuccess: isValid }"  :validator="v" :name="name" :inputclass="inputclass">
        <label v-if="label != ''">{{label}} <sup v-if="isRequired" class="text-danger">*</sup></label>
        <div class="input-group">
            <datepicker v-model="data" type="text" class="form-control" v-bind:class="[ (v.$error || verr[0]) ? 'border-danger' : '' , true ? inputclass : '' ]" :placeholder="placeholder"/>
            <button  v-if="data != ''" class="btn bg-white border border-left-0  no-border-left rounded-left-0 input-group-text" type="button" @click="clearDate"><i class="icon-cross"></i></button>
        </div>
        <div v-if="verr[0]" class="form-text errors text-danger">{{verr[0]}}</div>
    </validation>
</template>

<script>

import { singleErrorExtractorMixin } from "vuelidate-error-extractor";
import datepicker from './daterangepicker/datepicker.vue'

export default {
    mixins: [singleErrorExtractorMixin],
    components : {
        datepicker
    },
    props: {
        value: {
            type: String,
            default: ""
        },
        name: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            default: ""
        },
        inputclass :{
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        v: {
            type: Object,
            required: true
        },
        isLoading : {
            type: Boolean,
            default: false
        },
        isRequired : {
            type: Boolean,
            default: false
        },
        verr : {
            type: Array,
            default: []
        }
    },
    computed: {
        data: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            }
        }
    },
    methods : {
        clearDate : function(){
            this.data = ''
        },
    }
};
</script>